



















































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import { DepositAccountSettingsModule } from '@/store/Accounts/DepositAccountSettingsModule';
import AccountDepositInstantAccessSettings from '@/models/Accounts/DepositAccounts/Settings/AccountDepositInstantAccessSettings';
import AccountDepositInstantAccessSettingsEditDialog from '@/components/Accounts/DepositAccounts/Wallets/DefaultWallet/InstantAccess/AccountDepositInstantAccessSettingsEditDialog.vue';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'AccountDepositInstantAccessSettingsRead', components: { AccountDepositInstantAccessSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: AccountDepositInstantAccessSettings;

    async deleteDepositInstantAccessAccountSettings() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the overridden account settings?', options);
        if (result) {
            await DepositAccountSettingsModule.deleteDepositInstantAccessSettings();
        }
    }

}
